var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunrise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sunrise",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFBE00;}\n\t.st1{fill:#E95D0F;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Sunrise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.4,251.4c0-63.2-51.2-114.4-114.4-114.4s-114.4,51.2-114.4,114.4c0,34.7,15.8,67.6,42.9,89.3h143 C354.6,319,370.4,286.1,370.4,251.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,59.5L256,59.5c6.1,0,11,4.9,11,11v30.8c0,6.1-4.9,11-11,11l0,0c-6.1,0-11-4.9-11-11V70.5 C245,64.4,249.9,59.5,256,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,116.3c-8.3,0-15-6.7-15-15V70.5c0-8.3,6.7-15,15-15c8.3,0,15,6.7,15,15v30.8 C271,109.6,264.3,116.3,256,116.3z M256,63.5c-3.9,0-7,3.1-7,7v30.8c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7V70.5 C263,66.7,259.9,63.5,256,63.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.4,115.7L120.4,115.7c4.3-4.3,11.3-4.3,15.6,0l21.8,21.8c4.3,4.3,4.3,11.3,0,15.6l0,0 c-4.3,4.3-11.3,4.3-15.6,0l-21.8-21.8C116.1,127,116.1,120,120.4,115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.9,160.2c-3.8,0-7.7-1.5-10.6-4.4l-21.8-21.8c-5.8-5.8-5.8-15.4,0-21.2v0c5.8-5.8,15.4-5.8,21.2,0 l21.8,21.8c5.8,5.8,5.8,15.4,0,21.2C157.6,158.8,153.8,160.2,149.9,160.2z M123.2,118.5c-2.7,2.7-2.7,7.2,0,9.9l21.8,21.8 c2.7,2.7,7.2,2.7,9.9,0c2.7-2.7,2.7-7.2,0-9.9l-21.8-21.8c-1.3-1.3-3.1-2.1-4.9-2.1S124.5,117.2,123.2,118.5L123.2,118.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.2,251.3L64.2,251.3c0-6.1,4.9-11,11-11H106c6.1,0,11,4.9,11,11l0,0c0,6.1-4.9,11-11,11H75.2 C69.1,262.3,64.2,257.4,64.2,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106,266.4H75.2c-8.3,0-15-6.7-15-15s6.7-15,15-15H106c8.3,0,15,6.7,15,15S114.2,266.4,106,266.4z  M75.2,244.3c-3.9,0-7,3.1-7,7s3.1,7,7,7H106c3.9,0,7-3.1,7-7s-3.1-7-7-7H75.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M447.8,251.3L447.8,251.3c0,6.1-4.9,11-11,11H406c-6.1,0-11-4.9-11-11l0,0c0-6.1,4.9-11,11-11h30.8 C442.9,240.3,447.8,245.3,447.8,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.8,266.4H406c-8.3,0-15-6.7-15-15s6.7-15,15-15h30.8c8.3,0,15,6.7,15,15S445.1,266.4,436.8,266.4z  M406,244.3c-3.9,0-7,3.1-7,7s3.1,7,7,7h30.8c3.9,0,7-3.1,7-7s-3.1-7-7-7H406z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.6,115.7L391.6,115.7c4.3,4.3,4.3,11.3,0,15.6L369.9,153c-4.3,4.3-11.3,4.3-15.6,0l0,0 c-4.3-4.3-4.3-11.3,0-15.6l21.8-21.8C380.4,111.4,387.4,111.4,391.6,115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.1,160.3c-4,0-7.8-1.6-10.6-4.4c-2.8-2.8-4.4-6.6-4.4-10.6s1.6-7.8,4.4-10.6l21.8-21.8 c5.8-5.8,15.4-5.8,21.2,0c2.8,2.8,4.4,6.6,4.4,10.6s-1.6,7.8-4.4,10.6l-21.8,21.8C369.9,158.7,366.1,160.3,362.1,160.3z  M383.9,116.5c-1.8,0-3.6,0.7-5,2l-21.8,21.8c-1.3,1.3-2,3.1-2,4.9s0.7,3.6,2,4.9c1.3,1.3,3.1,2.1,5,2.1c1.9,0,3.6-0.7,4.9-2 l21.8-21.8c1.3-1.3,2-3.1,2-4.9s-0.7-3.6-2-4.9l0,0C387.5,117.2,385.7,116.5,383.9,116.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.4,342.9c-0.9,0-1.8-0.3-2.6-0.9c-49.9-42.1-56.4-116.9-14.3-166.8c17.4-20.7,41.7-34.9,68.2-40 c26.6-5.1,54.3-0.9,78.2,11.9c1.9,1,2.7,3.5,1.6,5.4c-1,1.9-3.5,2.7-5.4,1.6c-45.7-24.4-103.1-13.4-136.5,26.3 c-39.2,46.6-33.2,116.4,13.3,155.6c1.7,1.4,1.9,3.9,0.5,5.6C184.6,342.4,183.5,342.9,182.4,342.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.8,341.9c-1.1,0-2.2-0.5-3-1.4c-1.4-1.7-1.3-4.2,0.4-5.6c39.1-33.9,49.5-91.4,24.6-136.7 c-1.1-1.9-0.4-4.4,1.6-5.4c1.9-1.1,4.4-0.4,5.4,1.6c13,23.7,17.5,51.4,12.8,78c-4.8,26.6-18.7,51-39.1,68.7 C332.7,341.6,331.7,341.9,330.8,341.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.9,183.2c-5.6-7.1-12-13.5-19.1-19l4.9-6.3c7.6,5.9,14.5,12.8,20.5,20.4L342.9,183.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 404.7,
    y: 292.4,
    transform: "matrix(0.3826 -0.9239 0.9239 0.3826 -38.3178 571.9012)",
    className: "st1",
    width: 8,
    height: 44.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.3,
    y: 165.9,
    transform: "matrix(0.3825 -0.9239 0.9239 0.3825 -110.0218 211.5465)",
    className: "st1",
    width: 8,
    height: 44.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 386.5,
    y: 184.1,
    transform: "matrix(0.9239 -0.3826 0.3826 0.9239 -40.8634 170.6738)",
    className: "st1",
    width: 44.4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.1,
    y: 310.6,
    transform: "matrix(0.9239 -0.3826 0.3826 0.9239 -112.5175 63.4481)",
    className: "st1",
    width: 44.4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 297.1,
    y: 94.6,
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 105.9723 355.8332)",
    className: "st1",
    width: 44.4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 188.7,
    y: 76.4,
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -23.0683 81.2764)",
    className: "st1",
    width: 8,
    height: 44.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 336.7,
    className: "st1",
    width: 429,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 370,
    className: "st1",
    width: 286,
    height: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7,430l-38.5-26c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.1-0.5-0.2 c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.7-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.2,0-0.5,0-0.7,0.1c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.3c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0l-38.6,27.2 c-1.8,1.3-2.2,3.8-1,5.6c0.8,1.1,2,1.7,3.3,1.7c0.8,0,1.6-0.2,2.3-0.7l32.3-22.8v37.4c0,2.2,1.8,4,4,4s4-1.8,4-4v-37.6l32.3,21.8 c1.8,1.2,4.3,0.8,5.6-1.1C299.1,433.8,298.6,431.3,296.7,430z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.3b166766d7d462c17100ef4e49819dca.svg";
export { ForwardRef as ReactComponent };